import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home/index'
import about from '@/views/aboutus/aboutus'
import servicesdemo from '@/views/servicesd/services'
import portfo from '@/views/portfolio/portf'
import pricing from '@/views/pricing/pricing'
import contactd from '@/views/contacts/contact'
// import aboutus from '@/views/aboutus/abouts'
import VueI18n from 'vue-i18n';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
    },{
      path: '/services',
      name: 'services',
      component: servicesdemo,
    },{
      path: '/portf',
      name: 'portfo',
      component: portfo,
    },{
      path: '/pricing',
      name: 'pricing',
      component: pricing,
    },{
      path: '/contact',
      name: 'contactd',
      component: contactd,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js